import { Textsms, Bookmark, LightMode, Nightlight } from "@mui/icons-material";
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Rating,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PopupBlog from "features/searchStore/components/PopupBlog";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";

export function DetailSection() {
  const storeData = useAppSelector(selectStoreDetail);

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const generateNumberOpts = () => {
    const options = [];

    for (let i = 1; i <= 6; i++) {
      const option = `${i}名`;
      options.push(
        <MenuItem key={option} value={i}>
          {option}
        </MenuItem>
      );
    }
    return options;
  };

  return (
    <Grid container width="1000px" spacing={3}>
      <Grid item xs={8}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          my={3}
        >
          <Box display="flex" alignItems="center">
            <Rating size="medium" value={storeData.Points.avg} readOnly />
            <Typography variant="h5" fontWeight="bold" sx={{ mx: 1 }}>
              {storeData.Points.avg.toString()}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" my={1}>
            {storeData.Budgets.day && storeData.Budgets.day.min && (
              <Box
                display="flex"
                alignItems="center"
                width="max-content"
                py={2}
                marginRight={1}
              >
                <Box
                  p={0.5}
                  bgcolor="#aaa"
                  borderRadius={25}
                  marginRight={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <LightMode fontSize="small" style={{ color: "white" }} />
                </Box>
                <Typography fontWeight="bold">{`￥${storeData.Budgets.day.min} ~ ￥${storeData.Budgets.day.max}`}</Typography>
              </Box>
            )}

            {storeData.Budgets.night && storeData.Budgets.night.min && (
              <Box display="flex" alignItems="center" width="max-content" p={2}>
                <Box
                  p={0.5}
                  bgcolor="#aaa"
                  borderRadius={25}
                  marginRight={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Nightlight fontSize="small" style={{ color: "white" }} />
                </Box>
                <Typography fontWeight="bold">{`￥${storeData.Budgets.night.min} ~ ￥${storeData.Budgets.night.max}`}</Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
          石窯などの設備と食材にこだわるブッフェは五感で美味しさを知る{" "}
        </Typography>

        <Typography>
          ホテルのオールデイダイニングとして、親しみのある定番の洋食メニューに加え、ブッフェでは上質な食材を贅沢に使用したレストラン自慢の料理の数々をブッフェラインにてご用意しています。又、ショーキッチンではお客様の目の前でシェフが調理し、華やかな雰囲気を演出しております。品数においても約100種類と豊富で、食べやすいポーションに仕上げた美しい料理を173席の広々とした店内でゆったりと寛いでお召し上がりいただけます。朝食からランチ、ディナーまで、さまざまな食事のスタイルで、、お客様の用途に合わせてご利用いただけます。{" "}
        </Typography>

        <Box display="flex" justifyContent="space-between" my={3}>
          <PopupBlog
            imgPath="/images/store-detail/blog1.avif"
            title="視界いっぱいに広がるゴージャスな夜景　大人の時間を愉しんで"
            content="昼は陽光降り注ぎ、夜はまばゆい夜景が素晴らしいXEX ATAGO GREEN HILLS。ロケーションや料理の良さだけではなく、魅力はなんと言っても10,000本も揃うボトルワイン。グラスワインも赤白ともに12種類以上揃うので、その時の気分に合う最高の1杯に出会えるはず。また、食後には併設のバーに移動して、シガーを愉しんだり、毎夜開かれる外国人アーティストによるJAZZやR&Bのライブ、また週末に行われるクラブイベントも必見。"
          />
          <PopupBlog
            imgPath="/images/store-detail/blog2.avif"
            title="贅沢な料理が味わえるイタリアン「Salvatore Cuomo Bros.」"
            content="東京のパノラマビューが一体となって深い満足を味わえる。料理はこれまでにない料理法で焼き上げる黒毛和牛フィレ肉や全国各地から自然の恵みを取り入れた新しいスタイルのステーキを提供。また魚介がたっぷりのパスタやフォアグラやトリュフを使った贅沢なイタリア料理は絶品。"
          />
          <PopupBlog
            imgPath="/images/store-detail/blog3.avif"
            title="「tempura & sushi An」"
            content="四季折々の新鮮な食材と職人技から生まれる華やかな料理の数々。寿司や会席コースをはじめ、天ぷらカウンターを新たに設け、目の前でご提供できる出来立ての天ぷらをご堪能ください。心配りが嬉しい繊細なおもてなしとともにゆったりとした和の音色と共にぜひ。"
          />
        </Box>
      </Grid>

      <Grid item xs={4} my={3} display="flex" justifyContent="center">
        <Box
          p={1}
          border={1}
          borderRadius={1}
          borderColor="divider"
          display="inline-block"
          flexDirection="column"
        >
          <Box display="flex" alignItems="center" px={2}>
            <Typography
              fontWeight="bold"
              flex={1}
              sx={{ width: "max-content" }}
            >
              人数{" "}
            </Typography>
            <FormControl size="small" sx={{ minWidth: "150px" }}>
              <Select
                placeholder="Min"
                fullWidth
                defaultValue="指定なし"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
              >
                <MenuItem value="指定なし">指定なし</MenuItem>
                {generateNumberOpts()}
              </Select>
            </FormControl>
          </Box>
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth">
            <Tab icon={<Nightlight />} iconPosition="start" label="ディナー" />
            <Tab icon={<LightMode />} iconPosition="start" label="ランチ" />
          </Tabs>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
            <DateCalendar disablePast />
          </LocalizationProvider>
        </Box>
      </Grid>
    </Grid>
  );
}
